import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const labelWrap: CSSObject = {
  position: 'relative',
  maxWidth: '100%',
};

const maxWrap: CSSObject = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  top: 0,
  bottom: 0,
  right: 12,
  pointerEvents: 'none',
  '> p': {
    fontSize: '12px',
    color: theme.color.grey600,
    '> span': {
      color: theme.color.grey300,
    },
  },
};

export { labelWrap, maxWrap };
